module.exports = __webpack_public_path__ + "static/media/1 18 kjerring.893d8700.mp3";